import { GridStateClass } from '@bryntum/grid';
import { createAction, props } from '@ngrx/store';

// Action to reset the grid state
export const resetGridState = createAction(
    '[Bryntum Grid State] Reset Grid State',
    props<{ bryntumComponentTypeId: number }>()
);

// Action to load the grid state from a server
export const loadGridState = createAction(
    '[Bryntum Grid State] Load Grid State',
    props<{ bryntumComponentTypeId: number }>()
);

// Action to save the grid state to a server
export const saveGridState = createAction(
    '[Bryntum Grid State] Save Grid State',
    props<{ bryntumComponentTypeId: number, configuration: Object }>()
);

// Action to reset the grid state successfully
export const resetGridStateSuccess = createAction(
    '[Bryntum Grid State] Reset Grid State Success',
    props<{ bryntumComponentTypeId: number }>()
);

// Action to reset the grid state with failure
export const resetGridStateFailure = createAction(
    '[Bryntum Grid State] Reset Grid State Failure',
    props<{ error: any }>()
);

// Action to load the grid state successfully
export const loadGridStateSuccess = createAction(
    '[Bryntum Grid State] Load Grid State Success',
    props<{ bryntumComponentTypeId: number, state: Object }>()
);

// Action to load the grid state with failure
export const loadGridStateFailure = createAction(
    '[Bryntum Grid State] Load Grid State Failure',
    props<{ error: any }>()
);

// Action to save the grid state successfully
export const saveGridStateSuccess = createAction(
    '[Bryntum Grid State] Save Grid State Success',
    props<{ bryntumComponentTypeId: number, state: Object }>()
);

// Action to save the grid state with failure
export const saveGridStateFailure = createAction(
    '[Bryntum Grid State] Save Grid State Failure',
    props<{ error: any }>()
);